export default __webpack_public_path__ + "static/cbgFlower-39718a11f7d0a053666e0f9c36057357.png";